import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import InfiniteScroll from 'react-infinite-scroll-component';
import ModalTransactionDetails from './ModalTransactionDetails';
import dateformat from 'dateformat';

const SkuTransactionList = (props) => {
    const { t } = useTranslation("dealer_sku_pannel");
    const [transactions, setTransactions] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState({});

    useEffect(() => {
        setTransactions(props.transactionList);
    }, [props]);

    const handleViewClick = (tx) => {
        setShowModal(true);
        setModalData(tx);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setModalData({});
    };

    return (
        <div className="container-fluid new-theme">
            <div className='dealer-card m-lg m-md-l m-md-r transactions-table'>
                <h2>All Transactions</h2>
                <div className={props?.isLoading ? "container-fluid loading result-wrap" : "container-fluid result-wrap"}>
                    <div className='table-responsive'>
                        <InfiniteScroll
                            dataLength={transactions.length}
                            next={props.loadMoreItems}
                            hasMore={props.hasMoreItems}
                        // loader={<h4 className="text-center">Loading...</h4>}
                        // endMessage={
                        //     <p className="text-center">
                        //         <b>No more transactions</b>
                        //     </p>
                        // }
                        >
                            <table className="table-style-2">
                                <thead>
                                    <tr>
                                        {/* dealercentral */}
                                        {props?.userRole === 'admin' && <th>{t('SKU_TRANSACTION_LIST.DEALERSHIP_DETAILS')}</th>}
                                        <th>{t('SKU_TRANSACTION_LIST.SKU_NAME')}</th>
                                        <th>{t('SKU_TRANSACTION_LIST.NET_PRICE')}</th>
                                        {props?.userRole === 'dealercentral' && <th>Discount</th>}
                                        {props?.userRole === 'dealercentral' && <th>Validity</th>}
                                        <th>{t('SKU_TRANSACTION_LIST.TRANSACTION_ID')}</th>
                                        {props?.userRole === 'admin' && <th>{t('SKU_TRANSACTION_LIST.PAID_VIA')}</th>}
                                        {props?.userRole === 'admin' && <th>{t('SKU_TRANSACTION_LIST.XENDIT_STATUS')}</th>}
                                        <th>{t('SKU_TRANSACTION_LIST.PAYMENT_STATUS')}</th>
                                        <th>{t('SKU_TRANSACTION_LIST.DATE')}</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {transactions.map((tx) => (
                                        <tr key={tx.id}>
                                            {props?.userRole === 'admin' && <td>
                                                <div>
                                                    <strong>{tx?.dealer?.organization}</strong>
                                                </div>
                                                <div className="text-muted">
                                                    {`ID - GCD${tx?.dealer?.id}`}
                                                </div>
                                                 <div className="text-muted">
                                                    {`Email - ${tx?.dealer?.dealership_email}`}
                                                </div>
                                                 <div className="text-muted">
                                                    {`Phone - ${tx?.dealer?.dealership_contact}`}
                                                </div>
                                            </td>}
                                            <td>{tx?.package?.name}</td>
                                            <td>{`Rp ${tx?.amount}`}</td>
                                            {props?.userRole === 'dealercentral' && <td>{`Rp ${tx?.package?.discount_to_be_shown}`}</td>}
                                            {props?.userRole === 'dealercentral' && <td>{`${tx?.package?.active_period_days} Days`}</td>}
                                            <td>{tx?.transaction_number}</td>
                                            {props?.userRole === 'admin' && <td>{tx?.payment_mode}</td>}
                                            {props?.userRole === 'admin' && <td>{tx?.payment_mode === 'Xendit' && !tx?.xendit_status ? tx?.payment_status ? String(tx?.payment_status).toUpperCase() : '-' : tx?.xendit_status ? tx?.xendit_status : '-'}</td>}
                                            {/* <td
                                                className={
                                                    tx?.package?.is_expired === '1'
                                                        ? 'text-success'
                                                        : tx?.package?.is_expired === '2'
                                                            ? 'text-danger'
                                                            : ''
                                                }
                                            >
                                                {tx?.package?.is_expired === '1'
                                                    ? 'Active'
                                                    : tx?.package?.is_expired === '2'
                                                        ? 'Expired'
                                                        : ''}
                                            </td> */}
                                            <td
                                                className={
                                                    ['Success', 'success', 'SUCCESS'].includes(tx?.payment_status)
                                                        ? 'text-success'
                                                        : ['FAILED', 'failed', 'Failed'].includes(tx?.payment_status)
                                                            ? 'text-danger'
                                                            : ''
                                                }
                                            >
                                                {tx?.payment_status ? String(tx.payment_status).toUpperCase() : '-'}
                                            </td>
                                            <td>{tx?.payment_status === 'success' && tx?.payment_date ? dateformat(tx?.payment_date, "yyyy-mm-dd HH:MM:ss") : tx?.created_at ? dateformat(tx?.created_at_at, "yyyy-mm-dd HH:MM:ss") : '-'}</td>
                                            <td>
                                                <button
                                                    className="btn-solid w-auto btn-sm bg-orange t-uppercase"
                                                    onClick={() => handleViewClick(tx)}
                                                >
                                                    View
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </InfiniteScroll>
                        {/* When no Records available */}
                        {!props?.isLoading && transactions.length === 0 ? (
                            <>
                                <div align="center" className="center" style={{ marginTop: "20px" }}>
                                    <h6 className="text-center text-danger text-bold">{t("Listing.NO_RECORD_FOUND")}</h6>
                                </div>
                            </>
                        ) : null}
                        {/* End No Records found */}
                    </div>
                </div>
            </div>

            {/* Modal */}
            <Modal
                show={showModal}
                onHide={handleCloseModal}
                className='modal-subscription modal-transaction'
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Transaction Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalTransactionDetails data={modalData} userRole={props?.userRole}/>

                </Modal.Body>
            </Modal>
        </div>
    );
};

export default SkuTransactionList;
